<script>
	// @ts-nocheck
	import slugify from 'slugify';
	import { trip } from '$lib/utils/tripStore';
	import { Map, X, File, ArrowRight } from 'lucide-svelte/icons';
	import * as Card from '$lib/components/ui/card';
	import * as Sheet from '$lib/components/ui/sheet';
	import { Button } from '$lib/components/ui/button';
	import { onMount } from 'svelte';
	import { Badge } from '../ui/badge';
	import { enhancedImages } from '$lib/utils/images';

	// Function to format duration
	function formatDuration(durationMinutes) {
		const hours = Math.ceil(durationMinutes / 60); // Round up to nearest hour
		if (hours >= 24) {
			const days = Math.ceil(hours / 24); // Round up to nearest day
			return `${days} day${days > 1 ? 's' : ''}`;
		} else {
			return `${hours} hour${hours > 1 ? 's' : ''}`;
		}
	}

	function formatPrice(price) {
		return `From AUD $${price.toFixed(2)}`;
	}

	function formatProductType(productType) {
		const productTypeLabels = {
			DAYTOUR: 'Day Tour',
			MULTIDAYTOUR: 'Multi-day',
			SHOREEXCURSION: 'Shore Excursion',
			PRIVATETOUR: 'Private'
		};

		return productTypeLabels[productType] || productType; // Fallback to original value if no mapping found
	}

	onMount(() => {
		// Load trip data from localStorage on component mount
		const storedTrip = localStorage.getItem('trip');
		if (storedTrip) {
			trip.set(JSON.parse(storedTrip));
		}

		// Subscribe to changes in the trip store and save to localStorage
		const unsubscribe = trip.subscribe((value) => {
			localStorage.setItem('trip', JSON.stringify(value));
		});

		// Unsubscribe when the component is destroyed
		return () => unsubscribe();
	});

	function removeFromTrip(productCode) {
		trip.update((currentTrips) => {
			return currentTrips.filter((t) => t.productCode !== productCode);
		});
	}
</script>

<Sheet.Root>
	<Sheet.Trigger>
		<Button
			aria-label="Open trip planner"
			class="relative h-8 w-8 rounded-full px-0"
			variant="ghost"
			size="icon"
		>
			<Map class="h-4 w-4" />
			<span class="sr-only">GitHub</span>
			{#if $trip.length > 0}
				<div
					class="absolute -right-1 top-0 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs text-white"
				>
					{$trip.length}
				</div>
			{/if}
		</Button>
	</Sheet.Trigger>
	<Sheet.Content side="right" class="overflow-auto">
		<Sheet.Header>
			<Sheet.Title class="font-heading">Plan your trip</Sheet.Title>
			<Sheet.Description>
				Your saved tours will be displayed below. Compare tours directly to get the most out of your
				trip to Tassie.
			</Sheet.Description>
		</Sheet.Header>
		{#if $trip.length > 0}
			<div class="flex flex-col items-center justify-center gap-4 py-4">
				{#each $trip as tour}
					<Card.Root class="w-full  overflow-hidden rounded-2xl    transition-all">
						<Card.Header class="relative w-full p-0 ">
							{#if tour.images && tour.images.length > 0}
								<enhanced:img
									alt={tour.name}
									class="h-32 w-full object-cover"
									src={Object.entries(enhancedImages).find(
										([key, value]) => key === tour.images[0].itemUrl
									)[1].default}
									sizes="(min-width: 640px) 50vw, 100vw"
									loading="lazy"
								/>
							{:else}
								<File class="h-32 w-full object-cover text-muted-foreground" />
							{/if}
							<Badge
								class="absolute left-6 top-4 bg-[#ffd451] text-foreground hover:bg-[#ffd451]/80"
								>{formatProductType(tour.productType)}</Badge
							>
							<Card.Title class="text-md px-4 py-4 font-heading ">{tour.name}</Card.Title>
							<Card.Description class="px-4 font-semibold "
								>{formatPrice(tour.advertisedPrice)}</Card.Description
							>
							<Card.Description class="px-4"
								>duration: {formatDuration(tour.durationMinutes)}</Card.Description
							>
						</Card.Header>

						<Card.Footer class="flex justify-between px-4 pb-2 pt-2">
							<Sheet.Close>
								<Button
									href={`/tours/${slugify(tour.name, { lower: true, strict: true, remove: `/[*+~.()'"!:@]/g` })}`}
									data-sveltekit-prefetch
									variant="link"
									class="pl-0 text-sm font-semibold text-foreground"
								>
									Book now <ArrowRight class="ml-2 h-4 w-4" />
								</Button>
							</Sheet.Close>
							<Button
								onclick={() => removeFromTrip(tour.productCode)}
								class="rounded-full"
								size="icon"
								variant="secondary"><X class="h-4 w-4" /></Button
							>
						</Card.Footer>
					</Card.Root>
				{/each}
			</div>
		{:else}
			<div class="flex flex-col items-center justify-center gap-4 py-4">
				<enhanced:img
					src="/src/lib/assets/illustrations/map.png"
					class="w-60"
					alt="Plan your perfect Tasmanian Experience"
				/>
				<p class="text-foreground/60">You haven't saved any tours yet.</p>
			</div>
		{/if}

		<Sheet.Footer class="flex items-center justify-center">
			<Sheet.Close class="mx-auto flex w-full items-center justify-center">
				<div class="mx-auto flex w-full items-center justify-center text-center">
					<Button
						href="/tours#dayTours"
						class="rounded-full bg-tt-red px-6 text-center font-bold hover:bg-tt-red/90"
						type="submit">View all tours</Button
					>
				</div>
			</Sheet.Close>
		</Sheet.Footer>
	</Sheet.Content>
</Sheet.Root>
